import Config from "src/Constants/Config";

import setCurrentPage from "src/Utils/setCurrentPage";

import store from "src/Reducers/store";
import { useSelector } from "react-redux";

import { Audios } from "@yamildiego/presentation-kit";

const PageId = 116;
const PreviousPageId = PageId - 1;
const NextPageId = PageId + 1;

const DATA_JOURNEY_ONE = () => {
  const currentPage = useSelector(() => store.getState().appReducer.currentPage);
  const muted = useSelector(() => store.getState().appReducer.muted);
  const audioSrc = `${Config.BASE_URL}/audios/death_claim/PRCX_18_Death Claim - ${PageId}.mp3`;

  return {
    bgImage: `${Config.BASE_URL}/images/death_claim/bg_opacity_16.png`,
    labels: [
      {
        icon: `${Config.BASE_URL}/images/icons/clock.png`,
        text: "4:10 PM",
      },
      {
        icon: `${Config.BASE_URL}/images/icons/location.png`,
        text: "Sonya's Home",
      },
      {
        icon: `${Config.BASE_URL}/images/icons/genesys.png`,
        text: "Co-browse",
        style: { backgroundColor: "#c3834e" },
      },
    ],
    text: "Franky offers co-browsing\nwith Sonya to assist in\ncompleting the online form.",
    back: { label: "Go Back", type: "back", startIcon: "arrow-left", onClick: () => setCurrentPage(PreviousPageId) },
    next: { label: "Continue", type: "next", endIcon: "arrow-right", onClick: () => setCurrentPage(NextPageId) },
    audio: <Audios muted={muted} pageNumber={PageId} currentPage={currentPage} audios={[{ src: audioSrc, timer: 0 }]} />,
  };
};

export default DATA_JOURNEY_ONE;
